import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as types from 'constants/actionTypes';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';

const SelectInputPackageReference = ({
  options, 
  id,
  name, 
  label, 
  floatingLabelText, 
  onChange, 
  error, 
  hintText, 
  className, 
  defaultValue 
}) => {
  const dispatch = useDispatch();
  // Access Redux state (value and error)
  const { [name]: reduxValue = "", error: formError = {} } = useSelector((state) => state.form) || {};
  const reduxError = formError ? formError[name] : "";

  // Handle the initial value and fallback to defaultValue if Redux value is not set
  const [localValue, setLocalValue] = useState(defaultValue ||reduxValue || '');
  const [localError, setLocalError] = useState(reduxError || '');

  // // Sync local state with Redux state if reduxValue changes
  useEffect(() => {
    if (defaultValue && reduxValue !== localValue ) {
      setLocalValue(defaultValue);
    }else if (reduxValue && reduxValue !== localValue && !defaultValue) {
      setLocalValue(reduxValue);
    }else if (reduxValue === ""){
      // If the redux value is undefined, set a default value on Redux
      dispatch({ type: types.FORM_INPUT, value: defaultValue || "", name });
    }
  }, [defaultValue, reduxValue]);

  // // Sync local error state with Redux error state
  useEffect(() => {
    if (reduxError && reduxError !== localError) {
      setLocalError(reduxError);
    }
  }, [reduxError]);

  // Handle value change
  const handleChange = (event) => {
    const selectedValue = event.target.value;
    setLocalValue(selectedValue);
    dispatch({ type: types.FORM_INPUT, value: selectedValue, name });

    const selectedItem = options.find(item => item.value === selectedValue);
    if (selectedItem)
      dispatch({ type: types.FORM_INPUT, value: selectedValue, name: `${name}Text` });

    if (onChange) {
        onChange(event)
    }
  };

  return (
    <div className={`form-group SelectInput ${className || ``}`}>
      <FormControl fullWidth variant="standard" error={Boolean(localError)} 
          id={name}
          name={name}>
        <InputLabel shrink>{label || floatingLabelText || hintText}</InputLabel>
        <Select
          value={localValue} // Set value to localValue, which is synced with Redux
          onChange={handleChange}
          label={label || floatingLabelText}
          InputLabelProps={{ shrink: true }}
          displayEmpty
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.text}
            </MenuItem>
          ))}
        </Select>
        {localError && !value && <FormHelperText>{localError}</FormHelperText>}
      </FormControl>
    </div>
  );
};

export default SelectInputPackageReference;